import {Baseline} from './Baseline';
import {Vision} from '../../vision/message/Vision';
import {VisionStep} from '../../vision/message/VisionStep';
import {VisionStepPerimeter} from '../../vision/message/VisionStepPerimeter';

export class FormulaEngineInstance {
baselines: {[key: string]: {[key: string]: Baseline}};
scenario: string;
vision: Vision;
visionStep: VisionStep;
visionStepPerimeter: VisionStepPerimeter;
}

